import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { initTheme } from "./lib/theme";
import "./index.css";

// Apply the persisted (or system-preferred) theme before React mounts so the
// page doesn't flash light then dark.
initTheme();

// Desktop browsers step a FOCUSED <input type="number"> on mouse-wheel /
// trackpad scroll, so scrolling a long form with the caret still in, say,
// the trigger box silently changes it. Blurring first lets the page scroll
// and leaves the value alone. App-wide, so every number box is covered.
document.addEventListener(
  "wheel",
  (e) => {
    const el = document.activeElement;
    if (el instanceof HTMLInputElement && el.type === "number" && el === e.target) {
      el.blur();
    }
  },
  { passive: true },
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
